module.exports = __webpack_public_path__ + "img/p3.5254b6b0.jpg";